import { render } from "./PostComments.vue?vue&type=template&id=1fbc4ac4&scoped=true"
import script from "./PostComments.vue?vue&type=script&lang=js"
export * from "./PostComments.vue?vue&type=script&lang=js"

import "./PostComments.vue?vue&type=style&index=0&id=1fbc4ac4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbc4ac4"]])

export default __exports__